export default __webpack_public_path__ + "static/media/logo5.9f3989ea.svg";